package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class SubjectMarkConfigRequest(
    @SerialName("subject_id") val subjectId: String,
    @SerialName("internal_mark") val internalMark: Double,
    @SerialName("main_mark") val mainMark: Double,
    @SerialName("total_mark") val totalMark: Double,
    @SerialName("has_grade") val hasGrade: Boolean = false,
    @SerialName("has_rank") val hasRank: Boolean = false,
    @SerialName("has_marks") val hasMarks: Boolean = false
)

@Serializable
data class ExamCreateRequest(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null,
    val title: String,
    @SerialName("exam_type") val examType: String = SystemLookupOptions.codes("EXAM_TYPE").firstOrNull().orEmpty(),
    @SerialName("max_marks") val maxMarks: Double,
    @SerialName("exam_date") val examDate: String,
    @SerialName("start_date") val startDate: String,
    @SerialName("end_date") val endDate: String,
    val status: String = SystemLookupOptions.codes("EXAM_STATUS").firstOrNull().orEmpty(),
    @SerialName("exam_id") val examId: String? = null,
    val published: Boolean = false,
    @SerialName("has_overall_grade") val hasOverallGrade: Boolean = false,
    @SerialName("has_overall_rank") val hasOverallRank: Boolean = false,
    @SerialName("has_overall_marks") val hasOverallMarks: Boolean = false,
    @SerialName("applicable_class_section_ids") val applicableClassSectionIds: List<String> = emptyList(),
    @SerialName("subject_mark_configs") val subjectMarkConfigs: List<SubjectMarkConfigRequest> = emptyList(),
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)

@Serializable
data class ExamUpdateRequest(
    @SerialName("title") val title: String? = null,
    @SerialName("exam_type") val examType: String? = null,
    @SerialName("start_date") val startDate: String? = null,
    @SerialName("end_date") val endDate: String? = null,
    val status: String? = null,
    @SerialName("max_marks") val maxMarks: Double? = null,
    @SerialName("has_overall_grade") val hasOverallGrade: Boolean? = null,
    @SerialName("has_overall_rank") val hasOverallRank: Boolean? = null,
    @SerialName("has_overall_marks") val hasOverallMarks: Boolean? = null,
    @SerialName("subject_mark_configs") val subjectMarkConfigs: List<SubjectMarkConfigRequest>? = null
)
